import { Box } from '@fundamentals'
import { Chip } from '@common/material'
import React from 'react'
import { PageUrls } from '@core/page-urls'
import { useRegisterContext } from '@modules/registers/details/RegisterContext'
import {
  ChecklistStatusCounts,
  RegisterItemChecklistProperty,
} from '@core/entities/register/RegisterItem'
import { Checklist } from '@core/entities/checklist/Checklist'

type ActiveChecklistStatusChipsProps = {
  registerItemId?: number
  totalChecklists?: number
  statusCountArray: Array<ChecklistStatusCounts>
  onChecklistClick?: () => void
}

export const ActiveChecklistStatusChips: React.FC<
  ActiveChecklistStatusChipsProps
> = ({
  registerItemId,
  totalChecklists,
  statusCountArray,
  onChecklistClick,
}) => {
  const { scope, registerId } = useRegisterContext()

  const handleChipClick = () => {
    if (onChecklistClick) {
      onChecklistClick()
    } else if (registerItemId) {
      window.open(
        PageUrls.registerItemDetails({
          organisationId: scope.organisationId,
          registerId,
          registerItemId,
          tab: 'checklists',
        }),
      )
    }
  }

  return (
    <Box display='flex' flexWrap='wrap' gap={1}>
      {totalChecklists >= 0 && (
        <Chip
          variant='outlined'
          label={totalChecklists}
          size='small'
          onClick={handleChipClick}
        />
      )}
      {statusCountArray.map(({ status, count }) => (
        <Chip
          key={status}
          color={Checklist.getStatusChipColor(status)}
          label={`${Checklist.getStatusString(status)} (${count})`}
          size='small'
          onClick={handleChipClick}
        />
      ))}
    </Box>
  )
}

type RegisterItemPropertyChecklistValueProps = {
  registerItemPropertyData: RegisterItemChecklistProperty<string>
  statusCountArray: Array<ChecklistStatusCounts>
  onChecklistClick?: () => void
}

export const RegisterItemPropertyChecklistValue: React.FC<
  RegisterItemPropertyChecklistValueProps
> = ({ registerItemPropertyData, statusCountArray, onChecklistClick }) => {
  if (registerItemPropertyData?.totalChecklists === 0) {
    return <Box sx={{ color: 'text.secondary' }}>-</Box>
  }

  return (
    <ActiveChecklistStatusChips
      totalChecklists={registerItemPropertyData?.totalChecklists}
      statusCountArray={statusCountArray}
      onChecklistClick={onChecklistClick}
    />
  )
}
